import React from "react";
import { useWatch } from "react-hook-form";
import { Redirect, Route } from "react-router";
import { isInternal } from "../../helpers";

const OrderRedirectRoute = (props) => {
  const [full_address, approximate_sqft] = useWatch({
    name: ["address_info.full_address", "order_info.sq_ft"],
  });
  return (!isInternal() && !full_address) ||
    (isInternal() && !approximate_sqft) ? (
    <Redirect to="/new-order" />
  ) : (
    <Route {...props} />
  );
};

export default OrderRedirectRoute;
